<template>
    <v-dialog v-model="listSettingsModal" max-width="1000" persistent>
        <v-card>
            <v-card-title class="headline">{{ t("Choose columns to show") }}</v-card-title>
            <v-card-subtitle class="subtitle-1 mb-0 pb-0">{{
                t("Select which fields will be selected")
            }}</v-card-subtitle>
            <v-card-text>
                <v-row no-gutters>
                    <v-col v-for="row in listSettingsColumns" :key="row.text" md="4" sm="12">
                        <div
                            v-if="row.value === 'status' && row.isSelected"
                            style="display: flex; flex-direction: row;"
                        >
                            <v-checkbox
                                hide-details
                                class="mt-0 mb-0"
                                @click.stop="toggleListSettingsColumn(row)"
                                :input-value="row.isSelected"
                            />
                            <v-select
                                v-model="selected"
                                :items="statusItems"
                                item-value="value"
                                item-text="title"
                                solo
                                dense
                                :label="row.text"
                                multiple
                                single-line
                                class="pr-4 pt-1"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0">
                                        <span>{{ t(item.title) }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text caption">
                                        (+{{ selected.length - 1 }})
                                    </span>
                                </template>
                            </v-select>
                        </div>
                        <v-checkbox
                            v-else
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(row)"
                            :label="t(row.text)"
                            :input-value="row.isSelected"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="bal-dark-gray" text @click="toggleListSettingsModal">
                    {{ t("Close") }}
                </v-btn>
                <v-btn color="bal-green" text @click="handleReturnClick">
                    {{ t("Save") }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar color="error" bottom :timeout="2500" :value="errorMsg">
            <div style="display: flex">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ t("You must choose more than zero columns.") }}</div>
            </div>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { workOrderMixin } from "@/mixins/work-order-mixin";
export default {
    name: "work-order-list-settings-modal",
    mixins: [workOrderMixin],
    data() {
        return {
            errorMsg: false,
            selected: [],
            needRefresh: false,
            statusItems: [
                {
                    title: this.t("Plan"),
                    value: "plan"
                },
                {
                    title: this.t("In progress"),
                    value: "in_progress"
                },
                {
                    title: this.t("Done"),
                    value: "done"
                },
                {
                    title: this.t("Confirmed"),
                    value: "confirmed"
                },
                {
                    title: this.t("Cancelled"),
                    value: "cancelled"
                }
            ]
        };
    },
    computed: {
        ...mapState("WorkOrderStore", [
            "listSettingsModal",
            "listSettingsColumns",
            "workOrdersTableHeaders",
            "statusForFiltering",
            "tableOptions",
            "searchWorkOrderString"
        ])
    },
    mounted() {
        document.addEventListener("keydown", this.handleEscClick);
    },
    watch: {
        listSettingsModal: function() {
            this.selected = this.statusForFiltering;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleEscClick);
    },
    methods: {
        ...mapMutations("WorkOrderStore", [
            "toggleListSettingsModal",
            "toggleListSettingsColumn",
            "setWorkOrdersTableHeaders",
            "setStatusForFiltering"
        ]),
        ...mapActions("UserStore", ["saveUserWorkOrdersTableColumnSettings"]),
        ...mapActions("WorkOrderStore", ["fetchWorkOrders"]),
        async handleReturnClick() {
            let counter = 0;
            await this.listSettingsColumns.forEach(x => {
                if (x.isSelected === true) counter++;
            });
            if (counter > 0) {
                if (this.selected.length === 0) this.selected = [...this.statuses];
                if (this.selected !== this.statusForFiltering) this.needRefresh = true;
                await this.setStatusForFiltering(this.selected);
                await this.setWorkOrdersTableHeaders();
                await this.toggleListSettingsModal();
                await this.saveUserWorkOrdersTableColumnSettings(this.workOrdersTableHeaders);
                if (this.needRefresh) {
                    await this.fetchWorkOrders({ options: this.tableOptions, search: this.searchWorkOrderString });
                    this.needRefresh = false;
                }
            } else this.errorMsg = true;
        },
        handleEscClick(e) {
            if (e.keyCode === 27 && this.listSettingsModal) {
                e.preventDefault();
                this.toggleListSettingsModal();
            }
        }
    }
};
</script>

<style scoped>
::v-deep .v-input__slot {
    min-height: 9px !important;
}
::v-deep .v-chip {
    max-height: 24px !important;
}
</style>
